import React, { useCallback, useContext } from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC, DropContainer } from '../HOC';
import { useBasicDrop } from '../utils/useBasicDrop';
import { PageEditorStoreContext } from '../store/PageEditorStore';

type Props = ElementConfigType;

const Placeholder = () => {
  return (
    <div className=" w-full h-40 flex justify-center items-center border border-dashed border-black">
      <span style={{ fontSize: '32px' }}>+</span>
    </div>
  );
};

const MultiColumnContainer = (props: Props) => {
  const { elements, privateSchema, id, ComponentItemRender, isContainer } = props;
  const { length } = elements;

  const renderInnerComponents = useCallback(() => {
    const componentsList = elements.map((item, index) => {
      return (
        <ComponentItemRender
          className="w-full md:w-1/2"
          key={item.nodeId}
          style={index !== length - 1 ? { marginRight: privateSchema?.marginRight } : {}}
          {...toJS(item)}
        />
      );
    });

    return elements.length === 0 ? <Placeholder /> : <>{componentsList}</>;
  }, [ComponentItemRender, elements, length, privateSchema?.marginRight]);

  return (
    <div className="h-full flex md:flex-row flex-col" id={id}>
      {elements.map((item, index) => (
        <props.ComponentBasicRender
          {...toJS(item)}
          className="w-full md:w-1/2"
          styles={
            index !== length - 1
              ? {
                  marginRight: privateSchema?.marginRight,
                }
              : {}
          }
          key={item.nodeId}
        />
      ))}
    </div>
  );
};

export const MultiColumnContainerHOC: MyComponentType<Props> = (props: any) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  return (
    <>
      {pageEditorStore.isRenderHtml ? (
        <MultiColumnContainer {...props} />
      ) : (
        <DropContainer {...props}>
          <MultiColumnContainer {...props} />
        </DropContainer>
      )}
    </>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/MultiColumnContainerComponentDefinition'));

MultiColumnContainerHOC.definition = {
  // id: 'columns-container-component',
  id: ComponentIdEnum.COLUMNS_CONTAINER_COMPONENT,
  name: '多列容器',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/D4UIJKSXjA1G0MP4klaTU.png?image_process=resize,w_200',
  position: 888, // 显示顺序
  isContainer: true,
  config: {},
  privateSchema: {
    subContainersNumber: 2, // 会有几个子容器
    marginRight: 2,
  }, // 组件自己的属性 不能通用的部分
  category: 'container',
  configForm: ConfigHOC(ConfigForm),
};
